(()=>{
  const header=document.querySelector('[data-antar-header]');
  if(!header)return;

  const toggle=header.querySelector('[data-antar-menu-toggle]');
  const menu=header.querySelector('[data-antar-mobile-menu]');
  const drawer=document.getElementById('offcanvas__mini_cart');
  const cartTriggers=[...document.querySelectorAll('[data-antar-cart-trigger]')];
  const searchToggle=header.querySelector('[data-antar-search-toggle]');
  const searchModal=document.querySelector('[data-antar-search-modal]');
  const searchForm=searchModal?.querySelector('[data-antar-search-form]');
  const searchInput=searchModal?.querySelector('[data-antar-search-input]');
  const searchClose=searchModal?.querySelector('[data-antar-search-close]');
  const searchBackdrop=searchModal?.querySelector('[data-antar-search-backdrop]');
  const searchResults=searchModal?.querySelector('[data-antar-search-results]');
  const searchDiscover=searchModal?.querySelector('[data-antar-search-discover]');
  const searchStatus=searchModal?.querySelector('[data-antar-search-status]');
  let open=false;
  let searchOpen=false;
  let searchAbort=null;
  let searchTimer=0;
  const touchLayout=window.matchMedia?.('(max-width: 820px)').matches;
  let syncMobileSearchRail=()=>{};

  const setScrolled=()=>header.classList.toggle('is-scrolled',window.scrollY>20);
  const syncBodyLock=()=>{
    document.documentElement.classList.toggle('antar-search-open',searchOpen);
    document.body.style.overflow=(open||searchOpen)?'hidden':'';
  };
  const setOpen=(next)=>{
    open=next;
    header.classList.toggle('menu-open',open);
    if(toggle){
      toggle.setAttribute('aria-expanded',String(open));
      const label=toggle.querySelector('.visually-hidden');
      if(label)label.textContent=open?'Close menu':'Open menu';
    }
    document.documentElement.classList.toggle('antar-menu-open',open);
    syncBodyLock();
  };

  const setSearchOpen=(next,{restoreFocus=false}={})=>{
    searchOpen=Boolean(next&&searchModal);
    searchModal?.classList.toggle('is-open',searchOpen);
    searchModal?.setAttribute('aria-hidden',String(!searchOpen));
    searchToggle?.setAttribute('aria-expanded',String(searchOpen));
    if(searchOpen){
      if(open)setOpen(false);
      syncBodyLock();
      requestAnimationFrame(()=>{
        searchInput?.focus({preventScroll:true});
        requestAnimationFrame(syncMobileSearchRail);
      });
    }else{
      syncBodyLock();
      if(restoreFocus)searchToggle?.focus({preventScroll:true});
    }
  };

  const syncDrawerState=()=>{
    const isOpen=Boolean(drawer&&drawer.classList.contains('active'));
    cartTriggers.forEach(trigger=>trigger.setAttribute('aria-expanded',String(isOpen)));
    if(drawer)drawer.setAttribute('aria-hidden',String(!isOpen));
    document.documentElement.classList.toggle('antar-cart-open',isOpen);
  };

  const openCart=(event)=>{
    if(!drawer||typeof drawer.open!=='function')return;
    event.preventDefault();
    event.stopPropagation();
    if(open)setOpen(false);
    if(searchOpen)setSearchOpen(false);
    drawer.open();
    syncDrawerState();
  };

  setScrolled();
  syncDrawerState();
  window.addEventListener('scroll',setScrolled,{passive:true});
  toggle?.addEventListener('click',()=>setOpen(!open));
  menu?.addEventListener('click',e=>{if(e.target.closest('a')&&!e.target.closest('[data-antar-cart-trigger]'))setOpen(false)});
  searchToggle?.addEventListener('click',event=>{event.preventDefault();event.stopPropagation();setSearchOpen(!searchOpen)});
  searchClose?.addEventListener('click',()=>setSearchOpen(false,{restoreFocus:true}));
  searchBackdrop?.addEventListener('click',()=>setSearchOpen(false,{restoreFocus:true}));
  cartTriggers.forEach(trigger=>trigger.addEventListener('click',openCart));
  window.addEventListener('keydown',e=>{
    if(e.key==='Escape'){
      if(searchOpen){setSearchOpen(false,{restoreFocus:true});return;}
      if(open){setOpen(false);toggle?.focus();}
      return;
    }
    if(e.key==='Tab'&&searchOpen&&searchModal){
      const focusable=[...searchModal.querySelectorAll('a[href],button:not([disabled]),input:not([disabled]),[tabindex]:not([tabindex="-1"])')].filter(el=>el.offsetParent!==null);
      if(focusable.length){
        const first=focusable[0];
        const last=focusable[focusable.length-1];
        if(e.shiftKey&&document.activeElement===first){e.preventDefault();last.focus();}
        else if(!e.shiftKey&&document.activeElement===last){e.preventDefault();first.focus();}
      }
    }
  });
  window.addEventListener('resize',()=>{if(window.innerWidth>820&&open)setOpen(false)});

  const searchCollections=searchModal?.querySelector('.antar-search-modal-collections');
  if(touchLayout&&searchCollections){
    const cards=[...searchCollections.querySelectorAll('.antar-search-collection-card')];
    let searchRailFrame=0;
    syncMobileSearchRail=()=>{
      searchRailFrame=0;
      if(!searchOpen||searchCollections.scrollWidth<=searchCollections.clientWidth+4){
        cards.forEach(card=>card.classList.remove('is-mobile-active'));
        return;
      }
      const trackRect=searchCollections.getBoundingClientRect();
      const leftEdge=Math.max(0,trackRect.left);
      const rightEdge=Math.min(window.innerWidth,trackRect.right);
      let winner=null,best=-1;
      cards.forEach(card=>{
        const rect=card.getBoundingClientRect();
        const visible=Math.max(0,Math.min(rect.right,rightEdge)-Math.max(rect.left,leftEdge));
        const ratio=visible/Math.max(1,rect.width);
        if(ratio>best){best=ratio;winner=card;}
      });
      cards.forEach(card=>card.classList.toggle('is-mobile-active',card===winner&&best>.18));
    };
    const scheduleSearchRail=()=>{if(!searchRailFrame)searchRailFrame=requestAnimationFrame(syncMobileSearchRail);};
    searchCollections.addEventListener('scroll',scheduleSearchRail,{passive:true});
    window.addEventListener('resize',scheduleSearchRail,{passive:true});
    cards.forEach(card=>{
      card.addEventListener('pointerdown',event=>{
        if(event.pointerType==='mouse')return;
        cards.forEach(item=>item.classList.remove('is-mobile-active'));
        card.classList.add('is-mobile-active','is-mobile-pressed');
      },{passive:true});
      const release=()=>{card.classList.remove('is-mobile-pressed');scheduleSearchRail();};
      card.addEventListener('pointerup',release,{passive:true});
      card.addEventListener('pointercancel',release,{passive:true});
      card.addEventListener('pointerleave',release,{passive:true});
    });
  }

  const escapeHTML=(value='')=>String(value).replace(/[&<>'"]/g,char=>({'&':'&amp;','<':'&lt;','>':'&gt;',"'":'&#39;','"':'&quot;'}[char]));
  const renderSearchProducts=(products,query)=>{
    if(!searchResults||!searchDiscover||!searchStatus)return;
    if(!products.length){
      searchResults.innerHTML=`<div class="antar-search-empty"><span>No exact match</span><h3>Try another word.</h3><p>Search by product name, collection, colour, or practice.</p><a href="${window.routes?.search_url||'/search'}?q=${encodeURIComponent(query)}&type=product">View full search <b>→</b></a></div>`;
      searchResults.hidden=false;
      searchDiscover.hidden=true;
      searchStatus.textContent=`No product matches for ${query}.`;
      return;
    }
    const cards=products.map(product=>{
      const image=product?.featured_image?.url||product?.featured_image||'';
      const alt=product?.featured_image?.alt||product?.title||'';
      const price=product?.price||product?.price_min||'';
      const isGiftCard=String(product?.type||'').toLowerCase()==='gift card'||String(product?.handle||'')==='antar-gift-card';
      const media=image?`<img src="${escapeHTML(image)}" alt="${escapeHTML(alt)}" loading="lazy">`:(isGiftCard?`<span class="antar-search-gift-card-art"><span>ANTAR</span><small>GIFT CARD</small><strong>Give them the choice.</strong></span>`:'');
      return `<a class="antar-search-result-card" href="${escapeHTML(product.url||'#')}"><span class="antar-search-result-media">${media}</span><span class="antar-search-result-copy"><small>${escapeHTML(product.type||'Antar')}</small><strong>${escapeHTML(product.title||'Product')}</strong>${price?`<em>${escapeHTML(price)}</em>`:''}</span><i aria-hidden="true">↗</i></a>`;
    }).join('');
    const allUrl=`${window.routes?.search_url||'/search'}?q=${encodeURIComponent(query)}&type=product`;
    searchResults.innerHTML=`<div class="antar-search-results-head"><span>Products</span><a href="${allUrl}">View all results <b>→</b></a></div><div class="antar-search-results-grid">${cards}</div>`;
    searchResults.hidden=false;
    searchDiscover.hidden=true;
    searchStatus.textContent=`${products.length} product${products.length===1?'':'s'} found for ${query}.`;
  };
  const runPredictiveSearch=async(query)=>{
    const clean=query.trim();
    if(!searchResults||!searchDiscover||!searchStatus)return;
    if(clean.length<2){
      searchAbort?.abort();
      searchResults.hidden=true;
      searchResults.innerHTML='';
      searchDiscover.hidden=false;
      searchStatus.textContent=clean.length?'Keep typing to search products.':'Start typing to search products.';
      return;
    }
    searchAbort?.abort();
    searchAbort=new AbortController();
    searchStatus.textContent=`Searching for ${clean}...`;
    try{
      const base=window.routes?.predictive_search_url||'/search/suggest';
      const response=await fetch(`${base}.json?q=${encodeURIComponent(clean)}&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last`,{signal:searchAbort.signal,headers:{Accept:'application/json'}});
      if(!response.ok)throw new Error('Search request failed');
      const data=await response.json();
      renderSearchProducts(data?.resources?.results?.products||[],clean);
    }catch(error){
      if(error.name==='AbortError')return;
      searchResults.hidden=true;
      searchDiscover.hidden=false;
      searchStatus.textContent='Live suggestions are unavailable. Press Enter to search.';
    }
  };
  searchInput?.addEventListener('input',()=>{
    window.clearTimeout(searchTimer);
    searchTimer=window.setTimeout(()=>runPredictiveSearch(searchInput.value),180);
  });
  searchForm?.addEventListener('submit',event=>{
    if(!searchInput?.value.trim()){
      event.preventDefault();
      searchInput?.focus();
    }
  });

  if(drawer){
    new MutationObserver(syncDrawerState).observe(drawer,{attributes:true,attributeFilter:['class']});
  }

  const updateCartCount=(count)=>{
    const badge=header.querySelector('[data-antar-cart-count]');
    const mobileCount=header.querySelector('[data-antar-mobile-cart-count]');
    const next=Math.max(0,Number.parseInt(count,10)||0);
    if(badge){
      badge.textContent=String(next);
      badge.hidden=next<1;
    }
    if(mobileCount){
      mobileCount.textContent=String(next);
      mobileCount.hidden=next<1;
    }
    cartTriggers.forEach(trigger=>{
      trigger.classList.toggle('is-has-items',next>0);
      trigger.setAttribute('aria-label',next>0?`Cart, ${next} item${next===1?'':'s'}`:'Cart, empty');
    });
  };

  const liveCartCount=document.getElementById('cart-notification-count');
  const initialBadge=header.querySelector('[data-antar-cart-count]');
  updateCartCount(liveCartCount?.textContent??initialBadge?.textContent??0);

  if(liveCartCount){
    new MutationObserver(()=>updateCartCount(liveCartCount.textContent)).observe(liveCartCount,{childList:true,subtree:true,characterData:true});
  }

  if(typeof subscribe==='function'&&typeof PUB_SUB_EVENTS!=='undefined'){
    subscribe(PUB_SUB_EVENTS.cartUpdate,(event)=>{
      const count=event&&event.cartData?event.cartData.item_count:null;
      if(count!==null&&count!==undefined)updateCartCount(count);
    });
  }
  document.addEventListener('antar:cart-change',event=>{
    const count=event?.detail?.count;
    if(count!==null&&count!==undefined)updateCartCount(count);
  });

  const WISHLIST_KEY='shopify-wishlist';
  const readWishlist=()=>{
    try{return (localStorage.getItem(WISHLIST_KEY)||'').split(',').map(item=>item.trim()).filter(Boolean)}catch(error){return []}
  };
  const writeWishlist=(items)=>{
    try{
      const unique=[...new Set(items.filter(Boolean))];
      if(unique.length)localStorage.setItem(WISHLIST_KEY,unique.join(','));
      else localStorage.removeItem(WISHLIST_KEY);
      return unique;
    }catch(error){return items}
  };
  const syncWishlistButtons=()=>{
    const saved=readWishlist();
    document.querySelectorAll('[data-antar-wishlist-toggle]').forEach(button=>{
      const handle=button.dataset.productHandle||'';
      const active=saved.includes(handle);
      button.classList.toggle('is-active',active);
      button.setAttribute('aria-pressed',String(active));
      const title=button.dataset.productTitle||'product';
      button.setAttribute('aria-label',active?`Remove ${title} from wishlist`:`Save ${title} to wishlist`);
    });
    document.querySelectorAll('[data-antar-wishlist-count]').forEach(counter=>{
      counter.textContent=String(saved.length);
      counter.hidden=saved.length<1;
    });
    document.querySelectorAll('[data-antar-wishlist-link]').forEach(link=>{
      link.classList.toggle('is-has-items',saved.length>0);
      link.setAttribute('aria-label',saved.length>0?`Wishlist, ${saved.length} saved item${saved.length===1?'':'s'}`:'Wishlist, empty');
    });
    return saved;
  };
  window.AntarWishlist={read:readWishlist,write:writeWishlist,sync:syncWishlistButtons};
  syncWishlistButtons();

  document.addEventListener('click',event=>{
    const wishlistButton=event.target.closest('[data-antar-wishlist-toggle]');
    if(wishlistButton){
      event.preventDefault();
      event.stopPropagation();
      const handle=wishlistButton.dataset.productHandle||'';
      if(!handle)return;
      const saved=readWishlist();
      const index=saved.indexOf(handle);
      if(index===-1)saved.push(handle);else saved.splice(index,1);
      const next=writeWishlist(saved);
      const wishlistGrid=wishlistButton.closest('[grid-wishlist]');
      if(wishlistGrid&&!next.includes(handle))wishlistButton.closest('.product-grid-item')?.remove();
      document.querySelector('.wishlist-page')?.classList.toggle('wishlist_exists',next.length>0);
      syncWishlistButtons();
      document.dispatchEvent(new CustomEvent('antar:wishlist-change',{detail:{items:next,count:next.length,handle}}));
      return;
    }

    const optionsButton=event.target.closest('[data-antar-hover-options]');
    if(optionsButton){
      event.preventDefault();
      event.stopPropagation();
      const targetId=optionsButton.getAttribute('aria-controls');
      const toggleButton=targetId?document.querySelector(`[data-antar-options-toggle][aria-controls="${CSS.escape(targetId)}"]`):null;
      if(toggleButton){
        if(toggleButton.getAttribute('aria-expanded')!=='true')toggleButton.click();
        requestAnimationFrame(()=>document.getElementById(targetId)?.querySelector('input:checked')?.focus({preventScroll:true}));
      }
    }
  });

  let wishlistSyncFrame=0;
  new MutationObserver(records=>{
    if(!records.some(record=>[...record.addedNodes].some(node=>node.nodeType===1&&(node.matches?.('[data-antar-wishlist-toggle]')||node.querySelector?.('[data-antar-wishlist-toggle]')))))return;
    cancelAnimationFrame(wishlistSyncFrame);
    wishlistSyncFrame=requestAnimationFrame(syncWishlistButtons);
  }).observe(document.body,{childList:true,subtree:true});

  document.addEventListener('shopify:section:load',()=>{setScrolled();syncDrawerState();syncWishlistButtons();setSearchOpen(false)});

  const reducedMotion=window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;
  const initHouseCards=()=>{
    if(reducedMotion||!window.matchMedia?.('(hover:hover) and (pointer:fine)').matches)return;
    document.querySelectorAll('.antar-footer-path-card').forEach(card=>{
      if(card.dataset.antarHouseMotion==='ready')return;
      card.dataset.antarHouseMotion='ready';
      let frame=0;
      let pointer=null;
      const reset=()=>{
        pointer=null;
        cancelAnimationFrame(frame);
        frame=0;
        card.style.setProperty('--house-x','50%');
        card.style.setProperty('--house-y','38%');
        card.style.setProperty('--house-rx','0deg');
        card.style.setProperty('--house-ry','0deg');
      };
      const render=()=>{
        frame=0;
        if(!pointer)return;
        const rect=card.getBoundingClientRect();
        const x=Math.max(0,Math.min(1,(pointer.clientX-rect.left)/rect.width));
        const y=Math.max(0,Math.min(1,(pointer.clientY-rect.top)/rect.height));
        const nx=(x-.5)*2;
        const ny=(y-.5)*2;
        card.style.setProperty('--house-x',`${(x*100).toFixed(1)}%`);
        card.style.setProperty('--house-y',`${(y*100).toFixed(1)}%`);
        card.style.setProperty('--house-rx',`${(-ny*2.2).toFixed(2)}deg`);
        card.style.setProperty('--house-ry',`${(nx*2.8).toFixed(2)}deg`);
      };
      card.addEventListener('pointerenter',event=>{pointer=event;render()});
      card.addEventListener('pointermove',event=>{pointer=event;if(!frame)frame=requestAnimationFrame(render)});
      card.addEventListener('pointerleave',reset);
      card.addEventListener('pointercancel',reset);
    });
  };
  initHouseCards();
  document.addEventListener('shopify:section:load',initHouseCards);
})();